import { notifications } from '@mantine/notifications';
import { useAddService } from '@/models/offers';
import { TService } from '@/models/services';
import ServiceSelector from '@/components/service-selector/ServiceSelector';

interface Props {
  offerId: number;
  opened: boolean;
  onClose: () => void;
  /** True when the offer already has a schedule this change would discard. */
  dropsSplitPlan?: boolean;
}

export default function AddServiceModal({
  offerId,
  opened,
  onClose,
  dropsSplitPlan = false,
}: Props) {
  const addService = useAddService();

  const handleSelect = async (service: TService) => {
    try {
      await addService.mutateAsync({
        offerId,
        serviceId: service.id,
        invalidateSplitPlan: dropsSplitPlan,
      });
      onClose();
    } catch (e) {
      notifications.show({
        color: 'red',
        title: 'Error',
        message: `Failed to add service: ${e}`,
      });
    }
  };

  return (
    <ServiceSelector
      opened={opened}
      onClose={onClose}
      onSelect={handleSelect}
      isAdditionalService
    />
  );
}
